import type { GetGridApiArgs } from '~services/api/grid/types';

export const getGridSerializeQueryArgs = (
	endpointName: string,
	queryArgs: Partial<GetGridApiArgs>
) => {
	const orderedKeys = Object.keys(queryArgs).sort() as (keyof GetGridApiArgs)[];

	return `${endpointName}-${orderedKeys
		.map((key) => {
			const value = queryArgs[key];
			return `${key}-${value !== undefined ? value.toString() : ''}`;
		})
		.join('-')}`;
};
